import { TranslationService } from '@core/translation/translation.service';
import { InvoicePosition } from '@shared/models/invoice-position';

export function findPositionsWithInvalidQuantity(
    positions: InvoicePosition[] | undefined | null,
): InvoicePosition[] {
    return (positions ?? []).filter((position) => {
        // Negative Mengen (z. B. Schlüsselpfand-Erstattung) und Teilmengen sind gültig.
        const quantity = Number(position.quantity);
        return !Number.isFinite(quantity) || quantity === 0;
    });
}

export function buildInvalidQuantityCheckoutError(positions: InvoicePosition[]): string {
    const positionTitles = positions
        .map((position) => position.title?.trim() || position.itemNumber?.trim() || `#${position.id ?? position.positionId ?? '?'}`)
        .join(', ');

    return TranslationService.translate(
        'accounting.financialDocuments.invoiceForm.error.positionQuantityInvalid',
        { positionTitles },
    );
}
